export default {
    namespaced: true,
    state: {
        measure_list_id: null,
    },
    mutations: {
        setMeasureListId : (state, payload) => {
          state.measure_list_id = payload;
        },
    },
    actions: {
        setMeasureListId : (state, payload) => {
          state.commit("setMeasureListId", payload);
        },
    },
}